"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefer = void 0;
var react_1 = require("react");
/**
 * Defer an action to be run later. By calling the returned method, the supplied function
 * will be called with the given parameter on next rerender. A rerender is then queued.
 *
 * @example
 * ```tsx
 * // console.log some message on next render
 * const deferMsg = useDefer((s: string) => console.log(s));
 *
 * const MyButton = <button onClick={() => {
 *    // ...
       deferMsg("second");
       console.log("first");
 *  }}>Click Me</button>;

    // when clicked...
    // --> "first"
    // --> "second"
 * ```
 *
 * @category Hook
 */
function useDefer(fn) {
    var _a = __read((0, react_1.useState)([false, null]), 2), _b = __read(_a[0], 2), shouldRun = _b[0], v = _b[1], setInstr = _a[1];
    (0, react_1.useEffect)(function () {
        if (shouldRun)
            fn(v);
        setInstr([false, null]);
    }, [shouldRun]);
    return function (e) {
        setInstr([true, e]);
    };
}
exports.useDefer = useDefer;
